module.exports = __webpack_public_path__ + "assets/call-center.042372fd.svg";